import {Box, styled, Typography} from "@mui/material";
import filesFolder from "../../assets/svg/files/filesFolder.png";
import {color} from "../../theme/includes/color";

export const BoardWrapper = styled(Box)({
  height: "100vh",
  position: 'relative',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch'
})

export const BoardCardsWrapper = styled(Box)({
  padding: "0 40px",

  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '16px',
})

export const BoardButtonsBox = styled(Box)({
  width: "max-content",
  borderRadius: '24px',
  background: 'linear-gradient(180deg, rgba(210, 213, 225, 0) 0%, #D2D5E1 100%)',
  backdropFilter: 'blur(0px)',

  display: "flex",
  gap: '12px',

  position: "fixed",
  left: '45%',
  bottom: '8px',
  zIndex: 999,
})

export const BoardEmptyFiles = styled(Box)({
  width: '100%',
  height: "75vh",

  borderRadius: '16px',
  backgroundColor: 'white',
  backgroundImage: `url(${filesFolder})`,
  backgroundSize: '200px 200px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center calc(50% - 100px)',

  textAlign: 'center',
})

export const BoardEmptyTitlesBox = styled(Box)({
  position: 'absolute',
  top: '65%',
  left: '40%',
  right: '40%',
})

export const BoardEmptyTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: 400,
  color: color('blue-100'),
})
export const BoardEmptySubTitle = styled(Typography)({
  maxWidth: 'max-content',
  fontSize: '24px',
  fontWeight: 400,
  color: color('blue-200'),

  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const BoardEmptySubTitleHelper = styled(Typography)({
  fontSize: '24px',
  fontWeight: 400,
  color: color('blue-200'),
})

